import {Component, Inject, OnInit, Optional} from '@angular/core';
import {APP_DIALOG_DATA, DialogService} from "../../../core/services/dialog.service";

@Component({
    selector: 'app-term-of-service',
    templateUrl: './term-of-service.component.html',
    styleUrls: ['./term-of-service.component.scss'],
    standalone: false
})
export class TermOfServiceComponent implements OnInit {

  withAgreeOption: boolean = this.data.withAgreeOption;
  agree: boolean = false;

  constructor(private dialogService: DialogService,
              @Inject(APP_DIALOG_DATA) @Optional() readonly data: { withAgreeOption: boolean }) {
  }

  ngOnInit(): void {
  }

  async closeWithAgree(): Promise<void> {
    if (!this.agree) {
      await this.dialogService.alert({title: 'エラー', content: '「本利用規約に同意する」にチェックしてください。'});
      return;
    }
    this.dialogService.hide(true, true);
  }

  async close(): Promise<void> {
    this.dialogService.hide(false, true);
  }
}
